import $ from "jquery"

$('.js-accordion-trigger').each(function(){
    $(this).on('click', function(){
        const headingAccordion = $(this).closest('.faq__accordion-item').find('.faq__accordion-heading');

        if(headingAccordion.hasClass('faq-heading-active')){
            $(this).attr('title', 'faq collapse button');
            headingAccordion.removeClass('faq-heading-active');    
        }else{
            $('.faq__accordion-heading').removeClass('faq-heading-active');
            $('.faq__accordion-trigger').attr('title', 'faq expand button');
            headingAccordion.addClass('faq-heading-active');
            $(this).attr('title', 'faq collapse button');
        }
    });
});